export default "__VITE_PUBLIC_ASSET__c7053c2d__"